import React from "react";
import styles from "../functional.module.scss";
import Countdown from "react-countdown";

const renderer = ({days, hours, minutes, seconds, completed}) => {
  return (
    <div className={styles.timerContainer}>
      <div className={styles.timerItem}>
        <strong>{days}</strong>
        <span>days</span>
      </div>
      <div className={styles.timerItem}>
        <strong>{hours}</strong>
        <span>hrs</span>
      </div>
      <div className={styles.timerItem}>
        <strong>{minutes}</strong>
        <span>mins</span>
      </div>
      <div className={styles.timerItem}>
        <strong>{seconds}</strong>
        <span>sec</span>
      </div>
    </div>
  );
};

function CountDown({withdrawableTime}) {
  return (
    <>
      {withdrawableTime > 0 ? (
        <>
          <Countdown
            onComplete={() => {
              window.location.reload();
            }}
            date={Date.now() + withdrawableTime}
            renderer={renderer}
          />
        </>
      ) : (
        <div className={styles.timerContainer}>
          <span className={styles.withdrawText}>You can withdraw</span>
        </div>
      )}
    </>
  );
}

export default CountDown;
